import React, { HTMLAttributes, useState } from "react";
import CustomCalendar from "./common/CalendarComp.js/Calendar";
import Button from "./common/Button";
import clsx from "clsx";
import useToggle from "hooks/useToggle";
import moment from "moment";
import { Tooltip } from "react-tooltip";

type DateRangeFieldProps = {
    value: any;
    onChange: (value: any) => void;
    toolTipController?: any;
    required?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export default function DateRangeField(props: DateRangeFieldProps) {
    const { value, onChange, className, toolTipController, required, ...rest } = props;
    const [showDate, toggleShowDate] = useToggle(false);
    console.log("value", value);
    return (
        <div className={clsx(className && className, "relative")} {...rest}>
            <div
                id={`date-range-field`}
                onClick={toggleShowDate}
                className="flex relative items-center rounded-[6px] justify-between w-full h-[50px] px-[6px] !text-[#94A3B8]  !border !border-[#D0D4D7]"
            >
                <div
                    className={clsx(
                        `text-g-75 truncate px-[10px] py-[12px] text-[11px] xs:text-[13px]`,
                        value?.length > 0 ? "!text-slate-700" : "!text-[#94A3B8]"
                    )}
                >
                    {value?.length > 0
                        ? `${moment(new Date(value[0]))?.format("DD/MM/YYYY")} - ${moment(
                              new Date(value[1])
                          )?.format("DD/MM/YYYY")}`
                        : "Select forecast period from product"}
                    {required && <span className="required !text-r-50">*</span>}
                </div>
                <div className="flex-1" />
                <i className="ri-calendar-2-fill text-xs xs:text-lg text-g-75 !text-[#94A3B8]"></i>
            </div>

            {showDate && (
                <div
                    // ref={customRef}
                    className="w-[630px]  z-[10000] absolute  right-0 top-16 px-[28px] pt-8 pb-8 bg-white
            rounded-2xl shadow-[0px_0px_4px_rgba(0,0,0,0.04),0px_4px_32px_rgba(0,0,0,0.06)]"
                >
                    <CustomCalendar
                        showDoubleView={true}
                        selectRange={true}
                        value={value}
                        onChange={onChange}
                    />
                    <div className="flex justify-end">
                        <Button
                            btnText={"Close"}
                            btnClassname={"!w-fit !py-2"}
                            onClick={toggleShowDate}
                        />
                    </div>
                </div>
            )}

            <Tooltip
                anchorSelect={`#date-range-field`}
                place={"top"}
                // content={filter || value}
                style={{
                    maxWidth: "250px",
                    zIndex: 9999,
                    background: "#fff",
                    borderRadius: "6px",
                    border: "1px solid #E2E8F0",
                    color: "#1E293B",
                    boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.04)",
                }}
                {...toolTipController}
            />
        </div>
    );
}
